<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { $router } from '@/router'
import { $bus } from '@/common/events'
import { dialog } from '@/common/dialog'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'
import { useWebSocketBus, onWebSocketReceived, onWebSocketStatus, onWebSocketError } from '@/composables/WebSocketBus'
import { useJsonRpc } from '@/composables/jsonrpc'
import { EventEmitter } from 'events'
import EventLog from '@/components/EventLog.vue'

const deviceStatus = ref("init");
const status = ref();
const ready = ref();
const error = ref();

const groups = ref([

]);

const events = ref([

]);

const { wsbus } = useWebSocketBus();

console.log("wsbus", wsbus)
const { jsonrpc } = useJsonRpc({
  bus: wsbus
});

onWebSocketStatus((data) => {
  ready.value = data.ready;
  status.value = data.status;

  let type = "command";
  let text = data.status;

  if (data.status == "connected") {
    error.value = null;
    type = "success";
    text = data.ready ? "Authenticated" : "Connected";
    deviceStatus.value = data.ready ? "open" : "connecting";
  }
  if (data.status == "connecting") {
    type = "warning";
    text = "Connecting";
    deviceStatus.value = "connecting";
  }
  if (data.status == "disconnected") {
    type = "danger";
    text = "Disconnected";
    deviceStatus.value = "closed";
  }

  appendLog({ text: text, type: type, direction: "inbound" });
});

onWebSocketError((err) => {
  error.value = err;
  deviceStatus.value = "error";
  appendLog({ text: err.message || err, type: "danger", direction: "inbound" });
});

onWebSocketReceived((e) => {
  appendLog({ text: e.data, type: "comment", direction: "inbound", time: null });
});

const logRecords = ref([
  // { text: "18 23", time: "13:23:00", type: "command", direction: "outbound" },
  // { text: "OK", time: "13:23:00", type: "success", direction: "inbound", elapsed: "+34ms" },
  // { text: "DONE", time: "13:23:10", type: "success", direction: "inbound", elapsed: "+10245ms" },
  // { text: "0, 4; 11", time: "13:23:11", type: "warning", direction: "inbound" },
  // { text: "200 300", time: "13:23:30", type: "command", direction: "outbound" },
  // { text: "ERR", time: "13:23:30", type: "danger", direction: "inbound" },
]);

function appendLog(record) {
  if (!record.time && record.time !== null) {
    let now = new Date();
    let time = now.toISOString().split("T")[1].substr(0, 8);
    record.time = time;
  }
  logRecords.value.push(record);
}

function clearLogs() {
  logRecords.value = [ ];
}

const eventLogElement = ref();
const eventLogHeight = ref(300);

//Calculate event log height
function calculateEventLogHeight() {
  const minHeight = 150;
  const element = document.getElementById("eventLog");
  const offset = element.getBoundingClientRect(); //Get element position within the window
  eventLogHeight.value = Math.max(minHeight, window.innerHeight - offset.top - 90);
}

onMounted(() => {
  useTitle("WebSocket");
  useMenu("admin");
  useSubmenu(false);
  useTopBar(true);

  // setTimeout(() => {
  //   initMQTT();
  // }, 100);

  setTimeout(() => { }, 1);

  calculateEventLogHeight();

  //Restore last state
  if (jsonrpc.bus.connected) {
    deviceStatus.value = "connecting";
  }
  if (jsonrpc.bus.authenticated) {
    deviceStatus.value = "open";
  }

  jsonrpc.removeAllListeners("pong");
  jsonrpc.on("pong", (data) => {
    appendLog({ text: "Pong", type: "success", direction: "inbound" });
  });
});

onUnmounted(() => {
  jsonrpc.removeAllListeners("pong");
})

function initMQTT() {
  socket = io("/ws/v1/mqtt");
  socket.on('connect', () => {
    console.log("Socket:", socket.connected); // true
    responses.value.push({ color: "yellow", topic: "Socket", payload: "connected" });
  });
  socket.on('disconnect', () => {
    console.log("Socket:", socket.connected); // false
    responses.value.push({ color: "red", topic: "Socket", payload: "disconnected" });
  });
  socket.on('received', data => {
    console.log("received", data);
    if (counters.value[data.topic] > 0) {
      counters.value[data.topic]++;
    }
    else {
      counters.value[data.topic] = 1;
    }
    responses.value.push({ color: null, topic: data.topic, payload: data.payload });
  });
  socket.emit("subscribe", getTopics());
  console.log("init mqtt done")
}

function ping() {
  appendLog({ text: "Ping", type: "command", direction: "outbound" });

  try {
    let remote = jsonrpc.methods();
    remote.ping([1, 2, 5]);
  }
  catch (err) {
    appendLog({ text: err.message, type: "danger", direction: "outbound" });
  }
}

function goBack() {
  try {
    $router.push({ name: "Admin" });
  }
  catch (err) {
    dialog(err);
  }
}
</script>

<template>
  <div class="relative _min-h-screen dark:bg-gray-900 dark:text-white p-5">

    <!-- Header -->
    <div class="w-full mx-auto flex items-center justify-between">
      <div class="text-lg font-bold dark:text-white">{{ $t('admin.webSocketTest') }}</div>
      <div class="flex flex-row justify-items-strech space-x-2">
        <span class="ml-1 mr-1 mt-2">
          <i class="fa fa-power-off text-yellow-300 mt-1 animate-bounce" v-if="deviceStatus == 'init' || deviceStatus == 'connecting'"></i>
          <i class="fa fa-power-off text-red-600 mt-1" v-else-if="deviceStatus == 'closed' || deviceStatus == 'error'"></i>
          <i class="fa fa-power-off text-green-400 mt-1" v-else-if="deviceStatus == 'open'"></i>
          <i class="fa fa-power-off text-slate-400 mt-1" v-else></i>
        </span>
        <Button type="secondary" @click="goBack()">{{ $t('generic.back') }}</Button>
        <Button type="secondary" @click="clearLogs()">{{ $t('service.clearLog') }}</Button>
        <Button type="primary" @click="ping()" >{{ $t('admin.ping') }}</Button>
      </div>
    </div>

    <div class="w-full mt-4">
      <h6 class="w-full text-lg font-bold dark:text-white flex justify-between">
        <span>{{ $t('admin.eventLog') }}</span>
      </h6>
      <div class="w-full mt-2">
        <!-- <div class="w-full pb-4 mt-2 bg-white border border-gray-300 rounded-lg shadow overflow-x-hidden overflow-y-auto" style="height: 900px;" v-chat-scroll>
          <div v-for="event in events" class="w-full mb-1 px-3 py-2" :class="{ 'bg-blue-100 text-blue-800': !event.color, 'bg-green-100 text-green-800': event.color == 'green', 'bg-yellow-100 text-yellow-800': event.color == 'yellow', 'bg-red-100 text-re-800': event.color == 'red' }">
            <div class="font-medium">{{ event.topic }}</div>
            <div>{{ event.payload }}</div>
          </div>
        </div> -->
        <EventLog id="eventLog" ref="eventLogElement" :records="logRecords" :style="'height: ' + eventLogHeight + 'px'">
          <template #empty>
            {{ $t('service.no_logs') }}
          </template>
        </EventLog> 
      </div>
    </div>

  </div>
</template>

<style scoped>
</style>
